import React from 'react';

/**
 * SubmarineIcon component
 * A simple SVG submarine icon that can be styled via className
 * Props:
 * - className: string (optional) to adjust size/color via Tailwind
 */
export default function SubmarineIcon({ className = 'w-8 h-8 text-current' }) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Submarine Body */}
      <rect x="4" y="28" width="56" height="20" rx="10" fill="currentColor" />
      {/* Conning Tower */}
      <rect x="20" y="16" width="24" height="16" rx="4" fill="currentColor" />
      {/* Windows */}
      <circle cx="28" cy="38" r="3" fill="#fff" />
      <circle cx="36" cy="38" r="3" fill="#fff" />
      {/* Propeller */}
      <circle cx="58" cy="38" r="3" fill="currentColor" />
      <path
        d="M61,38 h4 m-2,-2 v4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      {/* Periscope */}
      <path
        d="M32,16 v-8 m0,0 h-8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      {/* Fins */}
      <path
        d="M4,48 l-8,4 l0,-8 z"
        fill="currentColor"
      />
    </svg>
  );
}
